export const Config = {
  "api_host": "/api/v1/",
  "public_client": "acme",
  "roi_cpa_campaign_margin": 0,
  "fullDateTimeFormat": "dd-MM-yyyy HH:mm",
  "dateTimeFormat": "dd-MM-yyyy",
  "timeFormat": "HH:mm",
  "defaultCurrency": "USD",
  "currencySymbol": "$",
  "search_debounce_delay": 750,
  "defaultLocale": "en-US",
  "defaultTimezone": "Asia/Kolkata",
  "basename": "/",
  "strategy_supply_type": "AAN",
  "support_link": "mailto:someone@yoursite.com?subject=Mail",
  "auth0": {
    "domain": "mediamath.auth0.com",
    "clientId": "LFwm2S1nAkGNPzAhoeK961UnR2gXv89O"
  },
  "defaultReportColumns": {
    "app-transparency": [
      "agency_name",
      "advertiser_name",
      "campaign_name",
      "strategy_name",
      "campaign_currency_code",
      "start_date",
      "end_date",
      "clicks",
      "ctr",
      "impressions",
      "total_conversions",
      "total_spend",
      "total_spend_cpa",
      "total_spend_cpc",
      "total_spend_cpm",
      "post_click_conversions",
      "post_view_conversions"
      ],
    "site-transparency": [
      "agency_name",
      "advertiser_name",
      "campaign_name",
      "strategy_name",
      "campaign_currency_code",
      "start_date",
      "end_date",
      "clicks",
      "ctr",
      "impressions",
      "total_conversions",
      "total_revenue",
      "total_spend",
      "total_spend_cpa",
      "total_spend_cpc",
      "total_spend_cpm",
      "post_click_conversions",
      "post_view_conversions"
      ],
    "geo": [
      "agency_name",
      "advertiser_name",
      "campaign_name",
      "strategy_name",
      "campaign_currency_code",
      "start_date",
      "end_date",
      "clicks",
      "ctr",
      "impressions",
      "total_conversions",
      "total_spend",
      "total_spend_cpa",
      "total_spend_cpc",
      "total_spend_cpm",
      "post_click_conversions",
      "post_view_conversions"
      ],
    "performance": [
      "agency_name",
      "advertiser_name",
      "campaign_name",
      "strategy_name",
      "start_date",
      "end_date",
      "impressions",
      "clicks",
      "total_spend",
      "total_conversions",
      "total_revenue",
      "total_spend_cpm",
      "ctr",
      "total_spend_cpc",
      "total_spend_cpa",
      ],
    "new-to-brand": [
      "agency_name",
      "campaign_id",
      "campaign_name",
      "total_conversions",
      "total_conversions_revenue",
      "total_unique_converters",
      "total_spend",
      "total_ntb_conversions",
      "total_ntb_revenue",
      "total_ntb_converters",
      "incremental_roas",
      ],
    "omnichannel-attribution": [
      "advertiser_id",
      "advertiser_name",
      "agency_name",
      "campaign_id",
      "campaign_name",
      "total_spend",
      "clicks",
      "impressions",
      "total_online_conversions",
      "total_offline_conversions",
      "total_online_revenue",
      "total_offline_revenue",
      "total_spend_online_roi",
      "total_spend_offline_roi",
      "total_conversions",
      "total_revenue",
      "total_spend_roi"
    ],
    "audience": [
      "advertiser_id",
      "advertiser_name",
      "audience_segment_name",
      "audience_vendor_name",
      "campaign_id",
      "campaign_name",
      "clicks",
      "end_date",
      "impressions",
      "start_date",
      "strategy_channel",
      "strategy_name",
      "strategy_type",
      "total_conversions",
      "total_offline_conversions",
      "total_offline_revenue",
      "total_online_conversions",
      "total_online_revenue",
      "total_revenue",
      "total_spend",
      "total_spend_offline_roi",
      "total_spend_online_roi",
      "total_spend_roi",
    ],
    "retail-attribution": [
      "advertiser_name",
      "advertiser_id",
      "agency_name",
      "agency_id",
      "campaign_name",
      "campaign_id",
      "start_date",
      "end_date",
      "product_brand",
      "product_id",
      "total_ppv",
      "total_atc",
      "abandonment_rate",
      "total_orders",
      "online_orders",
      "offline_orders",
      "total_units",
      "online_units",
      "offline_units",
      "total_product_revenue",
      "online_product_revenue",
      "offline_product_revenue",
      "total_roi",
      "online_roi",
      "offline_roi",
      "total_spend",
    ],
  },
  "hideReportColumns": {
    "app-transparency": ["ctc", "ctr", "impressions"],
    "site-transparency": [],
    "geo": [],
    "performance": [],
    "new-to-brand": [],
    "omnichannel-attribution": [],
    "audience": [],
    "retail-attribution": [],
  },
  "reportingRowsPerPage": 10
};
